var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'wrap ' + _vm.classes},[_c('v-tooltip',{attrs:{"top":"","color":"#333","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"helpicon",attrs:{"size":"22"}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" mehr icon ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.helptext)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }